/* eslint-disable no-param-reassign */
/**
 * This file specifies the state of the application in response to App actions
 */
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  factory: {
    data: null,
    loading: false,
    error: null,
  },
  factories: {
    data: [],
    count: 0,
    loading: false,
    error: null,
  },
  uploadFilesProgress: {},
};

const slice = createSlice({
  name: 'factories',
  initialState,
  reducers: {
    create: (state) => ({
      ...state,
      factory: {
        ...state.factory,
        loading: true,
        error: null,
      },
    }),
    createError: (state, action) => ({
      ...state,
      factory: {
        ...state.factory,
        loading: false,
        error: action.payload.error,
      },
    }),
    createSuccess: (state, action) => ({
      ...state,
      factory: {
        ...state.factory,
        data: action.payload.factory,
        loading: false,
        error: null,
      },
      factories: {
        ...state.factories,
        data: state.factories.data.map((f) => {
          if (f.id === action.payload.factory.id) return action.payload.factory;
          return f;
        }),
      },
      uploadFilesProgress: {},
    }),
    updateFile: (state, action) => ({
      ...state,
      factory: {
        ...state.factory,
        loading: true,
        error: null,
      },
    }),
    uploadFileProgress: (state, action) => {
      state.uploadFilesProgress[action.payload.fileName] =
        action.payload.progressEvent;
    },
    get: (state) => ({
      ...state,
      factory: {
        ...state.factory,
        loading: true,
        error: null,
      },
    }),
    getError: (state, action) => ({
      ...state,
      factory: {
        ...state.factory,
        loading: false,
        error: action.payload.error,
      },
    }),
    getSuccess: (state, action) => ({
      ...state,
      factory: {
        ...state.factory,
        data: action.payload.factory,
        loading: false,
        error: null,
      },
    }),
    getAll: (state) => ({
      ...state,
      factories: {
        ...state.factories,
        loading: true,
        error: null,
      },
    }),
    getAllError: (state, action) => ({
      ...state,
      factories: {
        ...state.factories,
        loading: false,
        error: action.payload.error,
      },
    }),
    getAllSuccess: (state, action) => ({
      ...state,
      factories: {
        ...state.factories,
        data: action.payload.rows,
        count: action.payload.count,
        loading: false,
        error: null,
      },
    }),
    update: (state) => ({
      ...state,
      factory: {
        ...state.factory,
        loading: true,
        error: null,
      },
    }),
    updateError: (state, action) => ({
      ...state,
      factory: {
        ...state.factory,
        loading: false,
        error: action.payload.error,
      },
    }),
    updateSuccess: (state, action) => ({
      ...state,
      factory: {
        ...state.factory,
        data: action.payload.factory,
        loading: false,
        error: null,
      },
      factories: {
        ...state.factories,
        data: state.factories.data.map((f) => {
          if (f.id === action.payload.factory.id) return action.payload.factory;
          return f;
        }),
      },
    }),
    delete: (state) => ({
      ...state,
      factory: {
        ...state.factory,
        loading: true,
        error: null,
      },
    }),
    deleteError: (state, action) => ({
      ...state,
      factory: {
        ...state.factory,
        loading: false,
        error: action.payload.error,
      },
    }),
    deleteSuccess: (state, action) => ({
      ...state,
      factory: {
        ...state.factory,
        data: action.payload.factory,
        loading: false,
        error: null,
      },
      factories: {
        ...state.factories,
        data: state.factories.data.filter(
          (f) => f.id !== action.payload.factory.id,
        ),
      },
    }),
  },
});

export const { reducer, actions } = slice;

export default reducer;
